import { StandaloneArticleHeader } from 'base/components/ArticleHeader';

export const MotherhoodStandaloneArticleHeader: typeof StandaloneArticleHeader = ({ options, ...props }) => {
  return <StandaloneArticleHeader options={{ variant: 'second', ...options }} {...props} />;
};

export default MotherhoodStandaloneArticleHeader;
